import React from 'react';
import {
    Button,
    Card,
    CardActions,
    CardContent,
    CardHeader,
    Grid,
    Typography,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import parse from 'html-react-parser';

import { CalendarIcon, LocationIcon } from '../icons/icons';

const useStyles = makeStyles((theme) => ({
    buttonOverFlow: {
        color: 'white',
        backgroundColor: '#52418a',
        top: -20,
        left: '80%',
        position: 'relative',
    },
    jobDiscription: {
        maxWidth: '100%',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
    },
    jobCard: {
        textAlign: 'start',
        position: 'relative',
        padding: 6,
        borderRadius: '40px 5px 5px 5px !important',
        background:
            'linear-gradient(180deg, rgba(255, 255, 255, 0.87) 0%, rgba(255, 255, 255, 0.94) 46.35%, rgba(255, 255, 255, 0.99) 100%) !important',
    },
}));

const JobOpeningCard = ({ position, onClick, mobileView = false }) => {
    const classes = useStyles();

    const textWrap = {
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        ml: '.2rem',
        mt: '.2rem',
    };

    return (
        <div>
            <Card className={classes.jobCard}>
                {/* <CardHeader
                    sx={{ pb: 1, textTransform: 'capitalize', fontSize: '1rem !important' }}
                    title={position?.position_name}
                /> */}

                <CardContent>
                    <Typography sx={{ mb: '1vh', fontSize: '1.18rem' }}>
                        {position?.position_name}
                    </Typography>
                    <Typography
                        variant='body2'
                        color='text.secondary'
                        component='div'
                        className={classes.jobDiscription}>
                        {position?.description?.replace(/(<([^>]+)>)/gi, '') || '-'}
                    </Typography>
                </CardContent>
                <CardActions>
                    <Grid container sx={{ mb: 3, ml: 2 }}>
                        <Grid item container xs={6} sm={6}>
                            <Grid item xs='auto'>
                                <LocationIcon fontSize='inherit' />
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant='body2' color='text.secondary' sx={textWrap}>
                                    {position?.position_location?.join(', ') || '-'}
                                </Typography>
                            </Grid>
                        </Grid>
                        <Grid item container xs={6} sm={6}>
                            <Grid item xs='auto'>
                                <CalendarIcon fontSize='inherit' />
                            </Grid>
                            <Grid item xs={9}>
                                <Typography variant='body2' color='text.secondary' sx={textWrap}>
                                    {position?.position_posted ? position?.position_posted : '-'}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </CardActions>
            </Card>
            <Button
                variant='contained'
                className={classes.buttonOverFlow}
                style={{ left: mobileView ? '75%' : '80%' }}
                onClick={() => onClick(position.id)}>
                Know More
            </Button>
        </div>
    );
};

export default JobOpeningCard;
